<script>
  import FaTwitter from 'svelte-icons/fa/FaTwitter.svelte';
</script>

<div class="header-secret columns is-vcentered">
  <div class="column is-2 mt-4 has-text-centered">
    <a
      class="bd-tw-button ml-3 twit"
      data-social-network="Twitter"
      data-social-action="tweet"
      data-social-target="#"
      target="_blank"
      href="https://twitter.com/IBOKYIV/"
    >
      <div class="icon"><FaTwitter /></div>
    </a>
  </div>
  <div class="column is-8 mt-2 has-text-centered lessSpaceMobile">
    <div class="logo">
      <p class="logo">INTERNATIONAL BRIGADE OF KYIV</p>
    </div>
  </div>
  <div class="column is-2 mt-2 has-text-centered lessSpaceMobile">
    <a
      class="button is-rounded buttonnavhover"
      href="https://mint.internationalbrigadeofkyiv.com"
      target="blank">MINT</a
    >
  </div>
</div>
